export default "__VITE_ASSET__5e625841__"